import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    createAPIDocumentEndpoint,
    Endpoint,
} from "../../Services/DocumentAdjustment/DocumnetAdjusService";
import Loader from "../../Components/Loader";
import storage from "../../Services/Storage";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Fa from "react-icons/fa";
import { format, subDays } from "date-fns";
import { Calendar } from "primereact/calendar";
import { toast } from "react-toastify";

const AllRecords = () => {
    const [loading, setLoading] = useState(false);
    const [allTableData, setAllTableData] = useState([]);
    const navlink = useNavigate();
    const auth = storage.getLocal("user");
    const date = subDays(new Date(), 7);
    const [fromDate, setFromDate] = useState(date);
    const [toDate, setToDate] = useState(new Date());
    const addNewPage = () => {
        navlink("/creditmanagement/documentadjustment/details");
    };

    const validateDateRange = () => {
        if (!fromDate || !toDate) {
            return false;
        }

        const start = new Date(fromDate);
        const end = new Date(toDate);

        const diffTime = end.getTime() - start.getTime();
        const diffDays = diffTime / (1000 * 3600 * 24);

        if (diffDays < 0) {
            return false;
        }

        if (diffDays > 92) {
            toast.warn("Maximum 92 days are allowed.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
            return false;
        }

        return true;
    };

    const pageLoad = () => {
        if (validateDateRange()) { 
            setLoading(true);
            createAPIDocumentEndpoint()
                .get(`${Endpoint.GetDocumentAdjustment}?CompId=${auth.CompId}&FromDate=${format(fromDate, "dd/MM/yyyy")}&ToDate=${format(toDate, "dd/MM/yyyy")}`)
                .then((response) => {
                // console.log("responseData", response.data.Data);
                    setAllTableData(response.data.Data);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    };

    useEffect(() => {
        pageLoad();
    }, []);

    const renderAction = (rowdata) => {

        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View Receipt Details"
                    >
                        <button
                            className="grid-icon"
                            onClick={() => {
                                navlink(
                                    `/creditmanagement/documentadjustment/details?MaskAdjId=${encodeURIComponent(
                                        rowdata.MASK_ADJ_ID
                                    )}`, { state: rowdata }
                                );
                            }}
                        >
                            <Fa.FaEye />
                        </button>
                    </div>
                </div>
            </>
        );
    };

    // const downloadData = ()=>{
    //     createAPIDocumentEndpoint()
    //         .get(`${Endpoint.GetDocumentAdjustment}?CompId=${auth.CompId}`)
    //         .then((response) => {
    //             console.log("responseData", response.data.Data);
    //             setAllTableData(response.data.Data);
    //             setLoading(false);
    //         })
    //         .catch(() => {
    //             setLoading(false);
    //         });
    // }

    if (loading) {
        return (
            <>
                <Loader />
            </>
        );
    } else {
        return (
            <main>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Document Adjustment</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="float-end">
                                <button type="button" className="btn btn-primary" onClick={addNewPage}>Add New</button>
                            </div>
                        </div>
                    </div>
                    <form>
                        <section className="sales-box">
                            <div className="row d-flex justify-content-end align-items-end">
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="d-block">
                                        <label className="form-label">From Date</label>
                                        <Calendar
                                            onChange={(e) => setFromDate(e.value)}
                                            showIcon
                                            value={fromDate}
                                            min="2010-01-01"
                                            dateFormat="dd/mm/yy"
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="d-block">
                                        <label className="form-label">To Date</label>
                                        <Calendar
                                            value={toDate}
                                            onChange={(e) => setToDate(e.value)}
                                            showIcon
                                            min="2010-01-01"
                                            dateFormat="dd/mm/yy"
                                        />
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-4 col-sm-12">
                                    <div className="float-end">
                                        <button type="button" className="btn btn-primary" onClick={pageLoad}>Get Data</button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </form>
                    <section className="">
                        <h3 className="py-2">Records</h3>
                        <div className="DataTable">
                            <DataTable
                                value={allTableData}
                                paginator
                                rows={10}
                                filterDisplay="row"
                                // showGridlines
                                stripedRows
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                emptyMessage="No Records found to display"
                                tableStyle={{ minWidth: "60rem" }}
                            >
                                <Column
                                    field="PARTY"
                                    header="Customer"
                                    style={{ minWidth: "12rem" }}
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="PAYABLE"
                                    header="Payable"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="RECEIVABLE"
                                    header="Receivable"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                    style={{ minWidth: "12rem" }}
                                ></Column>
                                <Column
                                    field="MASK_FIRST_ENTERED_ON"
                                    header="Created On"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                    style={{ minWidth: "12rem" }}
                                ></Column>
                                <Column
                                    field="COMMENTS"
                                    header="Comments"
                                    style={{ minWidth: "12rem" }}
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="STATUS"
                                    header="Status"
                                    style={{ minWidth: "12rem" }}
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column field={renderAction} header="Action" />
                            </DataTable>
                        </div>
                    </section>
                </div>
            </main>
        );
    }
};

export default AllRecords;
